import { useForm } from "react-hook-form";
import { CustomFormField } from "../../../../../utilis/component/CustomFormElement";
import {
  debounce,
  IconButton,
  Table,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import CustomTableBody from "../../../../../utilis/component/CustomTableBody";
import { useMemo, useState } from "react";
import { useQuery } from "react-query";
import { NoteAdd, ReceiptLong } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { base } from "../../../../../constants";
import moduleRoutes from "../../../../../routes/moduleRouteList";
import patientCareRouteList from "../../../../routeList";
import { FormOnChangeEventType } from "EMR/types";
import { getPatientLedgerDetails } from "../../Service";
import moment from "moment";

const PendingPaymentList = () => {
  const navigateTo = useNavigate();

  const { control } = useForm({
    defaultValues: {
      search: "",
      searchDate: moment().format("YYYY-MM-DD"),
      type: { id: 2, name: "All" },
    },
  });

  const [searchPayload, setSearchPayload] = useState({
    clinicId: 1,
    emrNo: "",
    filter: {
      search: "",
      pageSize: 25,
      pageNo: 0,
    },
  });

  const { data: allpatientsList, isLoading } = useQuery(
    ["pendingPayments", searchPayload],
    () => getPatientLedgerDetails(searchPayload),
    {
      // Switching this off ensures old data is cleared before new data is rendered
      keepPreviousData: false, 
      refetchOnWindowFocus: false,
    }
  );

  const handleChangePage = (_: unknown, newPage: number) => {
    setSearchPayload((prev) => ({
      ...prev,
      filter: { ...prev.filter, pageNo: newPage },
    }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newSize = parseInt(event.target.value, 10);
    setSearchPayload((prev) => ({
      ...prev,
      filter: { ...prev.filter, pageSize: newSize, pageNo: 0 },
    }));
  };

  const searchOnText = useMemo(
    () =>
      debounce((e: FormOnChangeEventType) => {
        const value = e.target.value;
        setSearchPayload((prev) => ({
          ...prev,
          emrNo: value,
          filter: { ...prev.filter, search: value, pageNo: 0 },
        }));
      }, 500),
    []
  );
const displayData = useMemo(() => {
  
  const resp = allpatientsList?.response as any; 
  return resp?.ledger || [];
}, [allpatientsList]);

const totalCount = (allpatientsList?.response as any)?.totalNo || 0;
  const headings = ["Sl No", "EMR No/Reg No", "Patient Name", "Action"];

  return (
    <>
      <form>
        <div className="grid grid-cols-8 gap-2 my-2">
          <div className="col-span-2">
            <CustomFormField
              control={control}
              element="input"
              name="search"
              rules={{ required: false, onChange: searchOnText }}
              fieldProps={{ label: "Search", type: "text" }}
            />
          </div>
        </div>
      </form>

      <Table size="small" sx={{ "& .MuiTableCell-root": { border: "1px solid", borderColor: "divider", padding: "1px 8px" } }}>
        <TableHead sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}>
          <TableRow>
            {headings.map((item) => (
              <TableCell key={item} align={item === "Action" ? "center" : "left"} sx={{ color: "white" }}>
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <CustomTableBody
          alert="No Patients Found"
          dataLoading={isLoading}
          isData={displayData.length > 0}
          totalSpan={{ col: headings.length, row: 5 }}
        >
          {displayData.map((item: any, index: number) => (
            // Unique key includes pageNo to force re-render on page switch
            <TableRow key={`${item.id}-${searchPayload.filter.pageNo}-${index}`}>
              <TableCell>
                {searchPayload.filter.pageNo * searchPayload.filter.pageSize + index + 1}
              </TableCell>
              <TableCell>{item.patientId}</TableCell>
              <TableCell>{`${item.firstName || ""} ${item.middleName || ""} ${item.lastName || ""}`}</TableCell>
              <TableCell align="center">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                  <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                    <IconButton
                      size="small"
                      onClick={() => {
                        const url = `${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${patientCareRouteList.paymentv2}/${item.encounterId}/${item.id}?emrno=${item.patientId}`;
                        console.log("urlurlurlurlurlurl",url)
                        navigateTo(url);
                      }}
                    >
                      <NoteAdd color="primary" />
                    </IconButton>
                  </div>
                  <div style={{ width: 1, height: 24, backgroundColor: "#ccc" }} />
                  <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                    <IconButton
                      size="small"
                      onClick={() => navigateTo(`${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${patientCareRouteList.patientLedgerDetails}?emrno=${item.patientId}`)}
                    >
                      <ReceiptLong color="secondary" />
                    </IconButton>
                  </div>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </CustomTableBody>
      </Table>

      <TablePagination
        component="div"
        count={totalCount}
        page={searchPayload.filter.pageNo}
        rowsPerPage={searchPayload.filter.pageSize}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50]}
      />
    </>
  );
};

export default PendingPaymentList;